module.exports = __webpack_public_path__ + "static/media/3DPPA39.357f7d3a.jpg";